import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BusinessModes from "../../Component/BussinessMode";
import "./style.css";
import "../dashboard-responsive.css";
import "./selling-cards-equal-height.css";
import { Helmet } from "react-helmet";

const SellingSide = () => {

  return (
    <>
      <div
        className="specificpage dashboard-responsive selling-side-dashboard"
        style={{ overflow: "hidden" }}
      >
        <Helmet>
          <body
            style={`background: linear-gradient(119.72deg, #15751F 5.7%, #0D3C82 93.64%);`}
          ></body>
        </Helmet>
        <Container fluid className="col-xl-10 col-lg-10 col-md-10 col-12 pt-3">
          <div className="screenHeight">
            <div>
              <Row>
                <div className="noscroll dashboard-scroll p-2">
                  <Col lg="12" sm="12" className="mt-sm-3 mt-lg-0 mt-md-0">
                    <BusinessModes
                      btntext="Create Now"
                      btntexttwo="Post"
                      btntextthree="Post Add"
                      btntextfour="Post Service"
                      chatroom="Chatroom"
                      helpline="Helpline"
                      email="Email"
                    />
                  </Col>
                </div>
              </Row>
            </div>
          </div>
        </Container>
      </div>
    </>

  );
};

export default SellingSide;
